export function getWhatsAppChatUrl() {
    return `https://wa.me/59176697125`;
}
